import { render, staticRenderFns } from "./InvoiceDocument.vue?vue&type=template&id=5ecf67a6&scoped=true&"
import script from "./InvoiceDocument.vue?vue&type=script&lang=js&"
export * from "./InvoiceDocument.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDocument.vue?vue&type=style&index=0&id=5ecf67a6&lang=scss&scoped=true&"
import style1 from "./InvoiceDocument.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecf67a6",
  null
  
)

export default component.exports